import * as React from 'react';
import { connect } from 'react-redux';

import LoginSso from '../components/LoginSso';
import * as built from '../built';

export default connect()(
  class LoginSsoContainer extends React.Component<
    LoginSsoContainerProps,
    LoginSsoContainerState
  > {
    constructor(props: LoginSsoContainerProps) {
      super(props);

      this.state = {
        busy: false,
        email: '',
        emailValid: false,
        showSsoError: false,
        showEmailError: false
      };
    }

    render() {
      const { busy, showSsoError, showEmailError } = this.state;
      return (
        <LoginSso
          busy={busy}
          showSsoError={showSsoError}
          showEmailError={showEmailError}
          onBackButtonClick={this.handleBackButtonClick}
          onEmailAddressChange={this.handleEmailAddressChange}
          onSubmit={this.handleSubmit}
        />
      );
    }

    /**
     * Prevents the user from leaving if a request is in flight
     */
    handleBackButtonClick = (event: React.SyntheticEvent<HTMLElement>) => {
      if (this.state.busy) {
        event.preventDefault();
        return;
      }
    };

    /**
     * Handles the change of the email address field and updates local
     * state with the details
     */
    handleEmailAddressChange = (email: string, emailValid: boolean) => {
      this.setState({
        email,
        emailValid,
        showEmailError: false
      });
    };

    /**
     * Checks for valid email and fires off a request to the API
     * to obtain a single sign-on redirect URL for the provided
     * email address; if we get a URL back, the browser will
     * redirect and start the SSO flow, otherwise we show an error
     */
    handleSubmit = (event: React.SyntheticEvent<HTMLElement>) => {
      event.preventDefault();

      // prevent the sso check if email is invalid
      if (!this.state.emailValid) {
        this.setState({ showEmailError: true });
        return;
      }

      // look up the redirect URL by email address
      this.setState({ busy: true });
      built
        .getSsoRedirect(encodeURIComponent(this.state.email))
        .then(resp => {
          if (resp && !resp.redirectUrl) {
            throw new Error('Missing redirectUrl');
          }
          // redirect the browser to start single sign-on
          window.location.href = resp.redirectUrl;
        })
        .catch(e => {
          // an error occurred, update state to show the
          // generic error
          this.setState({ busy: false, showSsoError: true });
        });
    };
  }
);

export interface LoginSsoContainerProps {}

export interface LoginSsoContainerState {
  /** Whether a request is in flight */
  busy: boolean;

  /** The current email address */
  email: string;

  /** Is the email address valid? */
  emailValid: boolean;

  /** Should we show the invalid email address error? */
  showEmailError: boolean;

  /** Should we show the SSO error? */
  showSsoError: boolean;
}



// WEBPACK FOOTER //
// ./src/containers/LoginSso.tsx